import ResetPasswordPage from "../../components/auth/reset-password"

const ResetPassword = () => {
  return (
    <div>
      <ResetPasswordPage />
    </div>
  )
}

export default ResetPassword
